<template>
  <div>
    <!-- <div v-if="!events.length">
      <div class="mx-1 has-background-white-bis" style="height: 36px; width: 100%"></div>
    </div>-->
    <div v-if="events.length" >
      <SectionHeader
        class="mx-1"
        :title="sectionHeaderTitle"
        :has-border-top="headerHasBorderTop"
        :title-lg="titleLg"
        :title-md="titleMd"
        :class="{'mb-half': !subtitle}"
      ></SectionHeader>

      <p
        v-if="subtitle"
        class="mx-1 has-text-weight-medium subtitle is-size-18px"
        style="margin-top: -8px; margin-bottom: 6px"
      >{{$t('ui.featured')}}</p>

      <b-carousel style="margin-bottom: 32px" v-if="isCarousel"  progress-type="is-dark" arrow has-drag :arrow-hover="false" :pause-info="false" arrow-both :interval="4000" >
        <b-carousel-item v-for="(event, i) in events" :key="i" style="border-radius: 6px;width: 94%; border-radius: 6px; overflow: hidden" class="mx-auto">
          <section :class="`hero is-medium `" >
            <router-link
              :to="{name: 'event-view', params: {eventID: event.id, eventPreview: event} }"
              @click.native="$analytics.logEvent('view_item', { page_name: $route.name, item_name: event.data.eventName, item_id: event.data.eventVenueID, button_name: 'card_on_featured_venue' })"
              class
            
            >
              <!-- <CardDatetime :show-type="false" :event-showtimes="event.data.eventShowtimes"></CardDatetime> -->
              <figure class="image is-16by9">
                <img
                  lazy="loaded"
                  class="is-lazy"
                  v-lazy="event.data.eventImagePaths.customPosterURLs[2]"
                  :alt="event.data.eventName"
                />
                <div class="subtype-card--content has-text-white" style="padding: 10px 12px">
                  <!-- <p class="is-size-13px has-text-weight-light">{{ 'n' }}</p> -->
                  <p
                    v-if="showType"
                    class="has-text-weight-medium is-size-xs is-uppercase"
                  >{{ $t(`evType.${event.data.eventMainType}`)}}</p>
                  <p
                    class="has-text-weight-semibold is-size-18px"
                    style="width: 60%; line-height: 1.25 !important;"
                  >{{ event.data.eventName }}</p>

                  <div style="bottom: 10px; position: absolute">
                    <CardDatetime
                      class="has-text-weight-medium is-size-14px"
                      style="color: white !important;  margin-bottom: 2px"
                      :show-type="false"
                      :event-showtimes="event.data.eventShowtimes"
                      :show-extra-dates="false"
                    ></CardDatetime>

                    <div
                      itemprop="location"
                      itemscope
                      itemtype="http://schema.org/Place"
                      class="card-row cursor-link"
                    >
                      <!-- HIDDEN MICRODATA LOCALIZATION -->
                      <div
                        style="height:0;width:0;overflow:hidden"
                        itemprop="address"
                        itemscope
                        itemtype="http://schema.org/PostalAddress"
                      >
                        <span
                          itemprop="streetAddress"
                        >{{ event.data.eventVenueRichAddress.streetAddress }}</span>
                        <br />
                        <span
                          itemprop="addressLocality"
                        >{{ event.data.eventVenueRichAddress.addressLocality }}</span>
                        <span>,</span>
                        <span
                          itemprop="addressRegion"
                        >{{ event.data.eventVenueRichAddress.addressRegion }}</span>
                        <span
                          itemprop="postalCode"
                        >{{ event.data.eventVenueRichAddress.postalCode }}</span>
                      </div>
                      <!-- END: HIDDEN MICRODATA LOCALIZATION -->
                      <link
                        itemprop="url"
                        :href="`https://hafta8.com/venue/${event.data.eventVenueID}`"
                      />
                      <div class="is-aligned-center">
                        <figure
                          class="image is-16x16 is-rounded has-escape"
                          style="margin-right: 6px"
                          v-if="false"
                        >
                          <img
                            v-if="event.data.eventVenueAvatarURL"
                            class="is-rounded"
                            :src="event.data.eventVenueAvatarURL"
                            :alt="event.data.eventVenueName"
                          />
                        </figure>
                        <div class="is-size-7 has-text-weight-medium cursor-link has-ellipsis">
                          <span>{{ event.data.eventVenueName }}</span>
                          <span
                            class="has-text-white-bis"
                          >, {{ event.data.eventVenueRichAddress.addressLocality }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </figure>
            </router-link>
          </section>
        </b-carousel-item>
      </b-carousel>

      <div
        v-if="!isCarousel"
        class="subtype-card--grid-wrapper"
        :style="`grid-template-columns: 96% repeat(${events.length-2}, minmax(92%, 1fr)) 96%;`"
      >
        <!-- <div class="grid-card--gap"></div> -->
        <router-link
          :to="{name: 'event-view', params: {eventID: event.id, eventPreview: event} }"
          @click.native="$analytics.logEvent('view_item', { page_name: $route.name, item_name: event.data.eventName, item_id: event.data.eventVenueID, button_name: 'card_on_featured_venue' })"
          class="subtype-card"
          v-for="event in events"
          :key="event.id"
        >
          <!-- <CardDatetime :show-type="false" :event-showtimes="event.data.eventShowtimes"></CardDatetime> -->
          <figure class="image is-2by1">
            <img
              lazy="loaded"
              class="is-lazy"
              v-lazy="event.data.eventImagePaths.customPosterURLs[2]"
              :alt="event.data.eventName"
            />
            <div class="subtype-card--content has-text-white" style="padding: 10px 12px">
              <!-- <p class="is-size-13px has-text-weight-light">{{ 'n' }}</p> -->
              <p
                v-if="showType"
                class="has-text-weight-medium is-size-xs is-uppercase"
              >{{ $t(`evType.${event.data.eventMainType}`)}}</p>
              <p
                class="has-text-weight-semibold is-size-18px"
                style="width: 60%; line-height: 1.35 !important;"
              >{{ event.data.eventName }}</p>

              <div style="bottom: 10px; position: absolute">
                <CardDatetime
                  class="has-text-weight-medium is-size-14px"
                  style="color: white !important;  margin-bottom: 2px"
                  :show-type="false"
                  :event-showtimes="event.data.eventShowtimes"
                  :show-extra-dates="false"
                ></CardDatetime>

                <div
                  itemprop="location"
                  itemscope
                  itemtype="http://schema.org/Place"
                  class="card-row cursor-link"
                >
                  <!-- HIDDEN MICRODATA LOCALIZATION -->
                  <div
                    style="height:0;width:0;overflow:hidden"
                    itemprop="address"
                    itemscope
                    itemtype="http://schema.org/PostalAddress"
                  >
                    <span
                      itemprop="streetAddress"
                    >{{ event.data.eventVenueRichAddress.streetAddress }}</span>
                    <br />
                    <span
                      itemprop="addressLocality"
                    >{{ event.data.eventVenueRichAddress.addressLocality }}</span>
                    <span>,</span>
                    <span
                      itemprop="addressRegion"
                    >{{ event.data.eventVenueRichAddress.addressRegion }}</span>
                    <span itemprop="postalCode">{{ event.data.eventVenueRichAddress.postalCode }}</span>
                  </div>
                  <!-- END: HIDDEN MICRODATA LOCALIZATION -->
                  <link
                    itemprop="url"
                    :href="`https://hafta8.com/venue/${event.data.eventVenueID}`"
                  />
                  <div class="is-aligned-center">
                    <figure
                      class="image is-16x16 is-rounded has-escape"
                      style="margin-right: 6px"
                      v-if="false"
                    >
                      <img
                        v-if="event.data.eventVenueAvatarURL"
                        class="is-rounded"
                        :src="event.data.eventVenueAvatarURL"
                        :alt="event.data.eventVenueName"
                      />
                    </figure>
                    <div class="is-size-7 has-text-weight-medium cursor-link has-ellipsis">
                      <span>{{ event.data.eventVenueName }}</span>
                      <span
                        class="has-text-white-bis"
                      >, {{ event.data.eventVenueRichAddress.addressLocality }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </figure>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import SectionHeader from "@/components/shared/SectionHeader";
import CardDatetime from "@/components/shared/CardDatetime";
export default {
  name: "featured-events",
  components: { SectionHeader, CardDatetime },
  props: {
    collectionName: {
      type: String,
      required: true
    },
    eventType: {
      type: String,
      required: true,
      default: ""
    },
    sectionHeaderTitle: {
      type: String,
      default: ""
    },
    headerHasBorderTop: {
      type: Boolean,
      default: true
    },
    showType: {
      type: Boolean,
      default: false
    },
    subtitle: {
      type: String,
      default: ""
    },
    titleMd: {
      type: Boolean,
      default: false
    },
    titleLg: {
      type: Boolean,
      default: false
    },
    orderLimit: {
      type: Number,
      default: 3
    },
    isCarousel: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      events: []
    };
  },
  created() {
    this.fetchFeaturedEvents();
  },
  methods: {
    async fetchFeaturedEvents() {
      try {
        let events = await this.$store.dispatch("appData/fetchFeaturedEvents", {
          eventType: this.eventType,
          orderLimit: this.orderLimit
        });
        if (process.env.NODE_ENV === "development") {
          console.log("fetchFeaturedEvents: ", events);
        }

        events = events.sort(
          (a, b) =>
            a.data.eventShowtimes[0].startTimeTimestamp.seconds -
            b.data.eventShowtimes[0].startTimeTimestamp.seconds
        );

        this.$emit("events-are-loaded", true);

        // this.events = events.sort(() => 0.5 - Math.random());
        this.events = events;
      } catch (error) {
        if (process.env.NODE_ENV === "development") {
          console.log(error);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.subtype-card--grid-wrapper {
  padding-bottom: 8px;
  //   margin-right: 16px;
  width: 100%;
  display: grid;
  grid-column-gap: 6px;
  grid-template-columns: 96% minmax(92%, 1fr) 96%;
  overflow-x: scroll;
  scroll-snap-type: x mandatory;
  -webkit-scroll-snap-type: mandatory;
  -webkit-scroll-snap-destination: 50% 50%;
}

.subtype-card {
  -webkit-scroll-snap-coordinate: 50% 50%;
  scroll-snap-align: center;
  display: inline-grid;
  // margin-top: 6px;

  figure {
    // margin-left: 4px;
    // margin-right: 4px;
    overflow: hidden;
    border-radius: 8px;
  }
  &:first-child {
    margin-left: 15px;
  }
  &:last-child {
    // margin-right: 16px;
    figure {
      margin-right: 16px;
    }
  }
  &--content {
    line-height: 1.4;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    // background-image: linear-gradient(
    //   to bottom left,
    //   rgba(245, 246, 252, 0),
    //   rgba(10, 10, 10, 0.33)
    // );
    // ,linear-gradient(
    //   to bottom ,
    //   rgba(245, 246, 252, 0),
    //   rgba(67, 67, 67, 0.43)
    // );
    text-shadow: 0px 0px 1px $black, 0px 0px 4px $black-ter !important;
  }
  .has-text-shadow {
    text-shadow: 0px 0px 1px $black, 0px 0px 4px $black-ter !important;
  }
}
</style>